import vk from '../assets/videos/vk.mp4';
import youtube from '../assets/videos/youtube.mp4';

export const tabs = [
    {
        id: 0,
        label: 'live:titles.vk',
        src: vk,
    },
    {
        id: 1,
        label: 'live:titles.youtube',
        src: youtube,
    },
];
